import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { DEFAULT_LANGUAGE, resolveInitialLanguage } from "../i18n/config";

/**
 * Idioma elegido por el usuario, persistido en el navegador.
 *
 * Ademas de pintar la interfaz, alimenta la cabecera `Accept-Language` de las
 * llamadas al backend, que es lo que localiza el contenido que viene de la base
 * de datos (por ejemplo, las categorias de terapia).
 *
 * `resolveInitialLanguage` en la rehidratacion no es decoracion: si alguien
 * probo un idioma mientras estuvo encendido y despues se apaga, su navegador
 * seguiria pidiendolo y veria un idioma retirado. Al rehidratar se comprueba
 * que siga disponible, y si no, vuelve al de por defecto.
 */
export const useLocaleStore = create()(
  persist(
    (set) => ({
      locale: DEFAULT_LANGUAGE,
      setLocale: (locale) => set({ locale: resolveInitialLanguage(locale) }),
    }),
    {
      name: "revi-locale",
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        const valido = resolveInitialLanguage(state.locale);
        if (valido !== state.locale) state.locale = valido;
      },
    },
  ),
);

/** Para codigo que no es un componente de React (por ejemplo, el cliente HTTP). */
export function getLocale() {
  return useLocaleStore.getState().locale;
}
